import { Block } from '@core/models/block/block.model';

export class ItemsBlock extends Block {
  protected constructor(data: any) {
    super(data);
  }
}
